import { jsx as _jsx } from "react/jsx-runtime";
import { Copyright } from "@air/next-icons";
import { memo } from "react";
import { InfoPanelDetailsSection } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailsSection";
import { InfoPanelDetailValue } from "~/components/AssetModal/shared/components/InfoPanel/components/shared/InfoPanelDetailValue";
import { isStringMetadataType } from "~/utils/iptcDataTypes";
export const InfoPanelCopyright = /*#__PURE__*/ memo((param)=>{
    let { clipMetadata } = param;
    const copyrightNotice = clipMetadata.find((metadata)=>metadata.fieldName === "CopyrightNotice");
    const usageTerms = clipMetadata.find((metadata)=>metadata.fieldName === "UsageTerms");
    if (!copyrightNotice || !isStringMetadataType(copyrightNotice) || !copyrightNotice.data) {
        return null;
    }
    return /*#__PURE__*/ _jsx(InfoPanelDetailsSection, {
        Icon: Copyright,
        title: "Copyright",
        children: /*#__PURE__*/ _jsx(InfoPanelDetailValue, {
            value: copyrightNotice.data,
            additionalInfo: !!usageTerms && isStringMetadataType(usageTerms) ? usageTerms.data : undefined
        })
    });
});
InfoPanelCopyright.displayName = "InfoPanelCopyright";
